module.exports = __webpack_public_path__ + "static/media/gift.9c8813b7.svg";